/* eslint-disable camelcase */
import { HeaderSection } from '@lmc/ui-kit'
import styled from 'styled-components'
import { SkillNeedTemplate_TrainingMatrix_SkillMatrix_Response } from '@lmc/ts-common'
import { withRouter } from 'withRouter'
import { useTranslation } from 'react-i18next'
import {
  SkillMatrix,
  DueOverDueTrainingMatrix,
  CapacityMatrix,
} from './components'

const Wrapper = styled.div`
  max-width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 24px;
  ${({ theme }) => theme.mediaQueries.mobileDown} {
    margin-left: 2%;
    margin-right: 2%;
  }
`

const Container = styled.div`
  width: 100%;
  max-width: 1080px;
`

const HeaderSectionStyled = styled(HeaderSection)`
  width: 100%;
`
export type SkillMatrixResponse =
  SkillNeedTemplate_TrainingMatrix_SkillMatrix_Response

const TrainingMatrixScreen = () => {
  const { t } = useTranslation()

  return (
    <Wrapper data-testid="training-matrix-screen">
      <Container data-testid="training-matrix-container">
        <HeaderSectionStyled
          title={t('skillsAndNeeds.skillMatrix')}
          testId="training-matrix-header"
        />
        <SkillMatrix testId="training-matrix-skill-matrix" />
        <DueOverDueTrainingMatrix testId="training-matrix-due-overdue" />
        <CapacityMatrix testId="training-matrix-capacity" />
      </Container>
    </Wrapper>
  )
}

export default withRouter(TrainingMatrixScreen)
